// components/ImageGallery.jsx
import React, { useState, useEffect } from 'react';

import FileAttachment from './FileAttachment';
import './ImageGallery.css';

function ImageGallery({ images, maxDisplay = 6, onImageClick }) {
    const [displayImages, setDisplayImages] = useState([]);
    const [extraCount, setExtraCount] = useState(0);

    useEffect(() => {
        if (!images || images.length === 0) {
            setDisplayImages([]);
            setExtraCount(0);
            return;
        }

        const display = images.slice(0, maxDisplay);
        setDisplayImages(display);
        setExtraCount(images.length - maxDisplay);
    }, [images, maxDisplay]);

    if (!images || images.length === 0) return null;

    return (
        <div className={`image-gallery image-count-${Math.min(images.length, maxDisplay)}`}>
            {displayImages.map((att, idx) => (
                <div 
                    key={idx} 
                    className="gallery-item" 
                    onClick={(e) => {
                        e.stopPropagation();
                        if (onImageClick) {
                            onImageClick(images, idx);
                        }
                    }}
                >                    
                    <FileAttachment 
                        mediaUrl={att.media_url} 
                        fileName={att.file_name}
                        className="gallery-image"
                    />
    
                    
                    {idx === maxDisplay - 1 && extraCount > 0 && (
                        <div className="gallery-overlay">
                            +{extraCount}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default ImageGallery;